import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vw-climate-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './climate-banner.component.html',
  styleUrl: './climate-banner.component.scss'
})
export class ClimateBannerComponent {
  @Input() selectedClimateType: string | null = null;
  @Input() myClimateType: string | null = null;
  @Output() pickerClick = new EventEmitter<void>();
}
